import Axios from 'axios';
import { requestAbortControllerInterceptor, responseAbortControllerErrorInterceptor, responseAbortControllerInterceptor, } from './abortControllerManage';
import { globalErrorHandlerInterceptor, globalRequestInterceptor, globalResponseInterceptor } from './interceptor';
const defaultConfig = {
    hideCodeErrorMessage: true,
    hideHTTPErrorMessage: true,
};
class CustomRequest {
    instance;
    constructor(config) {
        this.instance = this.createInstance(config);
    }
    createInstance(config) {
        const instance = Axios.create({ ...defaultConfig, ...config });
        this.setupInterceptors(instance, config);
        return instance;
    }
    setupInterceptors(instance, config) {
        const { interceptors } = config;
        instance.interceptors.request.use(globalRequestInterceptor);
        instance.interceptors.request.use(requestAbortControllerInterceptor);
        interceptors?.request && instance.interceptors.request.use(interceptors.request);
        instance.interceptors.response.use(responseAbortControllerInterceptor, responseAbortControllerErrorInterceptor);
        instance.interceptors.response.use(globalResponseInterceptor, globalErrorHandlerInterceptor);
        interceptors?.response && instance.interceptors.response.use(interceptors.response);
    }
    request(method, url, data, config) {
        const requestConfig = {
            ...config,
            method,
            url,
            data,
        };
        return this.instance.request(requestConfig);
    }
    post(url, data, config) {
        return this.request('POST', url, data, config);
    }
    get(url, config) {
        return this.instance.get(url, config);
    }
    patch(url, data, config) {
        return this.request('PATCH', url, data, config);
    }
    delete(url, config) {
        return this.request('DELETE', url, undefined, config);
    }
    put(url, data, config) {
        return this.request('PUT', url, data, config);
    }
    postForm(url, data, config) {
        return this.request('POST', url, data, config);
    }
    putForm(url, data, config) {
        return this.request('PUT', url, data, config);
    }
    patchForm(url, data, config) {
        return this.request('PATCH', url, data, config);
    }
    head(url, config) {
        return this.request('HEAD', url, undefined, config);
    }
    options(url, config) {
        return this.request('OPTIONS', url, undefined, config);
    }
}
export default CustomRequest;
